import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { HandleImageErrorDirective } from '../../../directives/handle-image-error.directive';

/**
 * Shows one chat attachment full-size: the thumbnails in the composer strip and in the sent
 * bubbles are 48-72px tiles, which is enough to tell two picks apart and not enough to read
 * what is actually in the image.
 *
 * Purely presentational - it is handed a URL and a name, and closes with nothing. It never
 * loads or deletes anything, so the same dialog serves a pending pick (whose URL is a local
 * object URL) and a sent attachment (whose URL is a presigned S3 link) without knowing which
 * it was given. Opened by AiChatConversationBase.openAttachmentPreview, so both chat surfaces
 * share it.
 */
@Component({
  selector: 'app-ai-chat-image-preview-modal',
  standalone: true,
  imports: [HandleImageErrorDirective, NgbTooltipModule],
  templateUrl: './ai-chat-image-preview-modal.component.html',
  styleUrl: './ai-chat-image-preview-modal.component.scss',
  // Required to reach the dialog shell: NgbModal renders .modal-dialog/.modal-content outside
  // this component's DOM, so sizing them needs unencapsulated rules. Every rule in the
  // stylesheet is scoped under the windowClass or the wrapper class to compensate.
  encapsulation: ViewEncapsulation.None
})
export class AiChatImagePreviewModalComponent {
  @Input() imageUrl = '';
  @Input() imageName = '';

  constructor(public activeModal: NgbActiveModal) {}
}
